<template>
  <div>
    
    <QuestionFormAnsweredModal
      ref="question-form-answered-modal"
      :answer_id="selected_answer_id"
    />

    <m-row>
      <m-col cols="6" >
        <div class="bottom-alignment">
          <strong>{{ $t('MEMBER.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>

      </m-col>
      <m-col cols="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
          />

        </div>
      </m-col>
    </m-row>


    <div v-if="loading" class="d-flex justify-content-center mb-8 mt-8">
      <memlist-spinner />
    </div>

    <memlist-ajax-table
      id="questions-answered-table"
      style="width: 100%; table-layout: fixed;"
      class="table-striped"
      :fields="headers"
      :items="ajax_pagination"
      :per-page="per_page"
      :current-page="current_page"
      head-variant="light"
      ref="questions-answered-table"
    >

      <template #cell(actions)="data">
        <memlist-table-button class="mr-2" @click="edit_item(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="'Redigera'" />
        <memlist-table-button class="mr-2" @click="delete_item(data.item.id)" svg="/assets/svg/trash2.svg" :tooltip="'Radera'" />
        <memlist-table-button class="mr-2" @click="download_item(data.item.id)" svg="/assets/svg/download-solid.svg" :tooltip="$t('Ladda ned PDF')" />
          
      </template>
    </memlist-ajax-table>
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import QuestionFormAnsweredModal from '@/view/pages/ml/questions/QuestionFormAnsweredModal.vue';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';

export default {
  name: 'QuestionsAnsweredTable',
  components: {
    QuestionFormAnsweredModal
  },
  data() {
    return {
      loading: false,
      filters: {},
      total_rows: 0,
      current_page: 1,
      per_page: 10,
      search: null,
      selected_answer_id: null
    };
  },
  mixins: [ toasts ],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods', 'settings', 'sid']),
  
    headers() {
      return [
        { label: 'Enkät', sortable: true, key: 'question_group', tdClass: 'td-overflow', thClass: 'td-overflow', formatter: (_, __, item) => item.question_form.name },
        { label: 'Grupp', sortable: true, key: 'company_id', tdClass: 'td-overflow', thClass: 'td-overflow', formatter: (_, __, item) => {
            return this.companies.find(i => i.company_id === item.company_id).name;
          }
        },
        { label: 'Besvarad av', sortable: true, key: 'answered_by', tdClass: 'td-overflow', thClass: 'td-overflow', formatter: (_, __, item) => item.member ? (item.member.firstname + ' ' + item.member.lastname) : item.email },
        { label: 'Besvarad tid', sortable: true, key: 'answered_at', tdClass: 'td-overflow', thClass: 'td-overflow', formatter: (_, __, item) => dayjs(item.created_at).format('YYYY-MM-DD') },
        { label: this.$t('COMMON.ACTIONS'), key: 'actions', sortable: false, }
      ];
    }
  },
  watch: {
    currentCompanyId() {
      this.$refs['questions-answered-table'].refresh();
    },
    companies: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.$refs['questions-answered-table'].refresh();
      }
    },
  },
  
  methods: {

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },


    async download_item(id) {
      try {
        const res = await axios.post(`/question_form/answers/${id}/pdf`, {});

        if (res.status === 201) {
          await this.delay(1000);
          
          downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
        }
        else if (res.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
        }  
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('PDF_TEMPLATE.UNABLE_CREATE'));
        }

      }
      catch (err) {
        console.error('download_item error', err);
      }

    },

    edit_item(item) {
      this.selected_answer_id = item.id;
      this.$refs['question-form-answered-modal'].show();
    },

    async delete_item(id) {
      const res = await axios.delete(`/question_form/answer/${id}`);

      if (res.status === 204) {
        this.$refs['questions-answered-table'].refresh();
        this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.DELETED'));
      }
      else if (res.status === 403) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.AN_ERROR_OCCURED'));
      }
    },
    
    async get_count() {
      

      const res = await axios.get(`/question_form/answers/count?company_ids=${encodeURIComponent('[' + this.companies.map(x => `"${x.company_id}"`).join(',') + ']')}`
      );

      this.total_rows = res.data.count;
    },

    async get_pagination(callback) {
      this.loading = true;

      //const options = this.get_options();

      try {
        console.log('this.companies', this.companies)
        const res = await axios.get(`/question_form/answers?page=${this.current_page}&limit=${this.per_page}&company_ids=${encodeURIComponent('[' + this.companies.map(x => `"${x.company_id}"`).join(',') + ']')}`);

        if (res.status === 200) {
          var arr = res.data;
          this.loading = false;

          if (callback) {
            callback(arr || []);
            return;
          }
        }
        else if (res.status === 403) {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.LACK_PERMISSION'));
        }
        
      }
      catch (err) {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.AN_ERROR_OCCURED'));
        console.error('pagination get error', err);
      }

    },

    ajax_pagination: function(ctx, callback) {
      const vm = this;

      let params = {
        pageNo: ctx.currentPage,
        pageSize: ctx.perPage,
        flag: 0,
        po: vm.searchOrderNumber,
        styNum: vm.searchStyleNumber
      };

      this.get_count();
      this.get_pagination(callback);

      return null;
    },


    refresh() {
      this.$refs['questions-answered-table'].refresh();
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
}
</style>
